import { render } from "./B2bTableMenuPlannedProcesses.vue?vue&type=template&id=277fa427&scoped=true&lang=pug"
import script from "./B2bTableMenuPlannedProcesses.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuPlannedProcesses.vue?vue&type=script&lang=js"

import "./B2bTableMenuPlannedProcesses.vue?vue&type=style&index=0&id=277fa427&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277fa427"]])

export default __exports__